<template>
  <div class="internal-contact-search">
    <div class="search-input-group">
      <span class="material-icons-sharp search-icon">search</span>
      <input
        type="email"
        v-model="email"
        @input="onInput"
        class="search-input"
        placeholder="Buscar por correo electrónico..."
      />
    </div>
    <div v-if="error" class="search-error">{{ error }}</div>
    <div v-if="foundUser" class="search-result">
      <div class="search-result__avatar">
        <span class="material-icons-sharp">person</span>
      </div>
      <div class="search-result__info">
        <div class="search-result__name">{{ foundUser.full_name }}</div>
        <div class="search-result__email">{{ foundUser.email }}</div>
      </div>
      <button @click="$emit('select', foundUser)" class="search-result__button">
        Seleccionar
      </button>
    </div>
  </div>
</template>

<style scoped>
.internal-contact-search {
  margin-bottom: 16px;
}

.search-input-group {
  display: flex;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 8px 12px;
}

.search-icon {
  color: #6c757d;
  margin-right: 8px;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
}

.search-error {
  color: #dc3545;
  font-size: 12px;
  margin-top: 8px;
}

.search-result {
  display: flex;
  align-items: center;
  padding: 12px;
  margin-top: 8px;
  border-radius: 12px;
  background: rgba(97, 29, 233, 0.05);
}

.search-result__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: rgba(97, 29, 233, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #611DE9;
  margin-right: 12px;
}

.search-result__info {
  flex: 1;
}

.search-result__name {
  font-weight: 600;
  font-size: 14px;
}

.search-result__email {
  font-size: 12px;
  color: #6c757d;
}

.search-result__button {
  padding: 6px 16px;
  border-radius: 8px;
  background: #611DE9;
  color: white;
  border: none;
  font-size: 12px;
  cursor: pointer;
}
</style>

<script>
export default {
  name: "InternalContactSearch",
  props: {
    searchUrl: {
      type: String,
      default: '/api/v2/users',
    },
  },
  data() {
    return {
      email: '',
      foundUser: null,
      error: null,
      debounceTimer: null,
    };
  },
  methods: {
    onInput() {
      this.error = null;
      this.foundUser = null;
      clearTimeout(this.debounceTimer);
      if (this.email.length < 3) return;
      this.debounceTimer = setTimeout(() => {
        this.$emit('search', this.email);
      }, 500);
    },
  },
};
</script>
